export const dirtyPhrases = [
  "Have you ever had a threesome? Would you?",
  "Tell us about an awkward or inappropriate sex dream you’ve had. Was anyone here involved?",
  "When was the last time you were tested for a sexually transmitted infection? What were the results?",
  "Have I ever popped into your head while you were masturbating? Will it happen now that we've asked the question?",
  "Who do you think has had more sexual partners, you or me?",
  "What’s the messiest thing you’ve ever done sexually?",
  "What was your best orgasm? Was it with yourself, or someone else?",
  "If we were stuck on a desert island, would we become lovers?",
  "Describe your first time having sex. Include every cringey detail.",
  "How many people have you hooked up with off dating apps?",
  "Have you ever been caught masturbating or having sex?",
  "Have you ever cheated on anyone? What were the circumstances?",
  "Have you ever had a one-night stand?",
  "Who do you think will have more sexual partners by the time we die, you or me?",
  "Have you ever walked in on your parents doing that thing that grownups do when they love each other very much?",
  "What was your most shame-filled orgasm?",
  "Who here would have the best sexual chemistry with me? Based on what evidence?",
  "What’s something you wish your ex would have done sexually but didn’t?",
  "Have I gotten sexier since you’ve known me?",
  "If I cheat on my partner, is it essential that I tell them? Why or why not?",
  "True or false: sometimes it’s okay to have unprotected sex. Explain your reasoning.",
  "Have you ever had sex with someone who was already in a committed relationship?",
  "If I had a hot brother/sister, would you let them seduce you?",
  "Have you ever slid into someone’s DMs? Any techniques you want to share?",
  "Assuming we were both single, would you date me?",
  "Have you ever feared for your life or safety while drinking or on drugs? Take us to the scene.",
  "How often are you intoxicated when you have sex? How often are you sober? What’s the difference?",
  "Do you find me physically attractive? What if I bat my eyelashes like this?",
  "What is your favorite sexual position and why?",
  "When was the last time you masturbated?",
  "What’s a sexual thing you’ve never been able to try, but wish you could?",
  "What’s your opinion on open relationships? What’s your experience with monogamy?",
  "What would it take for you to sleep with someone you’re not physically attracted to?",
  "If I had a hot mom/dad, would you let them seduce you?",
  "Have you ever served food or other edibles in an erotic context? How did it go?",
  "What would it take for us to have sex?",
  "What’s a sexual thing you gave a good try, but just couldn’t get into?",
  "Name the person here you’d most like to hook up with (but haven’t).",
  "What’s the last inanimate object you put inside yourself or another person?",
  "Do you have nude images of anyone that I know on your phone right now?",
  "How open are you about your most intimate fantasies with your partner(s)?",
  "If your sex life was a pie chart, what portion of it would be: satisfactory, unsatisfactory, and mind-blowing?",
  "Describe your sex life with a song title.",
  "Are you more sexperimental, or less sexperimental, than the average person?",
  "How much money would a voyeuristic billionaire have to pay us for us to have sex in his velvet blimp?",
  "What’s your most-complimented anatomical feature (as described by your lovers?)",
  "Who was the last person (besides your partner or your kids) whose junk you’ve seen?",
  "True or false: great sex requires a connection beyond physical attraction. Explain your thinking.",
  "Tell us about the first time you ever saw porn.",
  "True or false: great sex requires lube. State your case with first-hand evidence.",
  "Have you ever been injured while having sex?",
  "Have you ever paid for sex? Even if you haven’t, is there anything inherently problematic about it?",
  "Would you be (or have you been) a “guest star” in another couple’s bedroom?",
  "Describe the perfect foreplay: what activities, and for how long?",
  "The various sex juices. Sometimes they get on clothes. Tell us about when it happened to you.",
  "Have you ever sent nudes? How do you compose, frame, and light these images?",
  "What do you think is your most unique sexual interest?",
  "Who was the last person (besides your partner or your doctor) who’s seen your junk?",
  "Have you ever cried after—or during—sex?",
  "Do you have an age ceiling for a one-night stand?",
  "Have you ever had to contact past partners for... public health reasons?",
  "If we were in a porn together, what category would it be filed under?",
  "What’s the weirdest porn that you’ve ever clicked on?",
  "What’s the maximum number of people you’d be interested in having sex with at once?",
  "Looking for a weird but true story about an inappropriate boner.",
  "Have you ever found yourself wearing somebody else’s underwear?",
  "Who’s had more sex, you or your parents?",
  "Quick! Name your favorite porn star. And tell us about all the wonderful qualities that make them special.",
  "Inadvertent nudity. Tell us about when it happened to you.",
  "How would your partner (or your latest ex) describe your sex life with a movie title?",
  "What’s the most surprising discovery you’ve made about your own body?",
  "When was the last time you had unprotected sex? Did it ever cross your mind?",
  "If a studio were to make a porn specifically for you, tailored to your specific tastes, what would it be like?",
  "How did your parents talk to you about sex?",
  "What will be the sexy nickname they give you when you live at the old-folks’ home?",
  "Have you ever been sexual on camera? Would you want to?",
  "You can send a message back in time to your teenage self about sex. What advice will you impart?",
  "Who here is most likely to star in an adult film? Who here is most likely to make and direct porn?",
  "What sex-related word are you not sure how to pronounce?",
  "What’s the kinkiest thing you’ve asked someone else to do?",
  "If you can abstain from sex and masturbation for one full year, you’ll win $27,000 and a nice used car. Will you make it?",
  "Are you a good kisser? How do you know?",
  "What did you observe from porn that you later realized was unrealistic? How’d you make this discovery?",
  "Imagine we’re your future (or current) children. How do you present the birds-and-the-bees talk to us?",
  "What scared you the most about sex as you were coming of age?",
  "Do you see yourself committing to one sexual partner for the rest of your life?",
  "Do you think you have more or less sex than your next-door neighbors?",
  "Are you more of a top, a bottom, or versatile? Or do these labels not apply to you?",
  "What’s the kinkiest thing you were ever asked to do, but you declined instead?",
  "Are you loud during sex? Demonstrate with a dramatic interpretation of your signature sex sounds.",
  "Tell us about a time in which a romantic partner just didn’t understand how to do a certain sex thing.",
  "Do you have recurring fantasies that kind of trouble you, or surprise you? What are they?",
  "Have you ever had sexy times in public?",
  "Describe the present state of your pubic hair.",
  "How would you describe your nipples to a blind person?",
  "When it comes to your sexual orientation, have you ever considered experimenting?",
  "Have you ever paid for porn? If so—how much money is in your spank bank budget?",
  "Do you know where your G-spot is? Are you sure?",
  "List all the illicit drugs you’ve tried. What more would you like to try?",
  "How confident are you in your oral sex skills? How do you know?",
  "Give us a passionate example of your dirty talk.",
  "Would you ever knowingly enter into an open relationship? What rules are required to keep the peace?",
];
